export const ALL_ASSIGN_ID = 'ALL' as const
